import { APIRequestBase } from '@/models/api/models-api'

/**
 * Web-LINE認証準備取得リクエストクラス
 * @class PostLineOauthSetupRequest
 */
export class PostLineOauthSetupRequest extends APIRequestBase {
    /**
     * @constructor
     */
    constructor(_provisionShopCode, _larCode, _larPrm, _brandsite) {
        super()

        this.provisionShopCode = _provisionShopCode
        this.larCode = _larCode
        this.larPrm = _larPrm
        this.brandsite = _brandsite
    }

    /** @type {string} */
    provisionShopCode = null
    /** @type {string} */
    larCode = null
    /** @type {string} */
    larPrm = null
    /** @type {string} */
    brandsite = null
}
